import { Pill } from '@recruit-robin/robin-theme/web-components';
import { Copy_01 } from '@recruit-robin/robin-theme/web-icons';
import { useContext } from 'react';

import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useCreateSnackbar } from 'shared/legacy/contexts/SnackbarContext/useCreateSnackbar';

export const CopyButton = ({ text, successMessage }: { text: string | (() => string); successMessage: string }) => {
  const { dictionary } = useContext(LocalizationContext);
  const createSnackbar = useCreateSnackbar();

  const handleCopy = () => {
    if (text) {
      navigator.clipboard.writeText(typeof text === 'function' ? text() : text);

      createSnackbar(successMessage);
    }
  };

  return (
    <Pill
      startIcon={<Copy_01 size={14} />}
      label={dictionary.copyText}
      style="icon-removable"
      type="subtle1"
      onClick={handleCopy}
    />
  );
};
